import { InjectionToken } from '@angular/core';

import { fromEvent, map, Observable, shareReplay, startWith } from 'rxjs';

import { SHARE_REPLAY_SETTINGS } from '@bazis/configuration.service';

export type BazisWindowSizes = {
    width: number;
    height: number;
};

export const BAZIS_WINDOW_SIZES = new InjectionToken<Observable<BazisWindowSizes>>(
    'BAZIS_WINDOW_SIZES',
    {
        providedIn: 'root',
        factory: () =>
            fromEvent(window, 'resize').pipe(
                startWith(null),
                map(() => ({ width: window.innerWidth, height: window.innerHeight })),
                shareReplay(SHARE_REPLAY_SETTINGS),
            ),
    },
);
